import {
  FilterGroupingEnum,
  useFormCategoriesSearchListLazyQuery,
  useSitesSearchListLazyQuery,
  useUsersSearchListLazyQuery,
} from 'graphql-common';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getSitesLoadOptions as getSitesLoadOptionsFn } from 'utils/fetch/searchLists/sitesSearchList';
import { getFormCategoriesLoadOptions as getFormCategoriesLoadOptionsFn } from 'utils/fetch/searchLists/formCategoriesSearchList';
import { getUsersLoadOptions as getUsersLoadOptionsFn } from 'utils/fetch/searchLists/usersSearchList';

export default function useQueries() {
  // Sites query
  const [fetchSitesSearchListLazyQuery] = useSitesSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getSitesLoadOptions: GetLoadOptions = () =>
    getSitesLoadOptionsFn(fetchSitesSearchListLazyQuery);

  // Form categories query
  const [fetchFormCategoriesLazyQuery] = useFormCategoriesSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getFormCategoriesLoadOptions: GetLoadOptions = () =>
    getFormCategoriesLoadOptionsFn(fetchFormCategoriesLazyQuery);

  // Users
  const [fetchUsersSearchListLazyQuery] = useUsersSearchListLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getUsersLoadOptions = () => {
    return getUsersLoadOptionsFn(fetchUsersSearchListLazyQuery, undefined, [
      {
        email: {
          grouping: FilterGroupingEnum.Or,
          predicate: { null: false },
          filterGroup: 'email',
        },
      },
    ]);
  };

  return {
    getSitesLoadOptions,
    getFormCategoriesLoadOptions,
    getUsersLoadOptions,
  };
}
